<template>
  <div>
    <div>
      <h5> Select a date range to filter results </h5>
      <div style="float:left">
        <label>Start Date:</label>
        <datepicker
          v-model="startDate"
          name="uniquename"
          placeholder='DD/MM/YYYY'
        />
        <div style="float:left">
          <button style="margin:5px" @click="dateSelected"> Search </button>
          <button style="margin:5px" @click="resetData"> Reset </button>
        </div>
      </div>

      <div style="float:left">
        <label>End Date:</label>
        <datepicker
          v-model="endDate"
          name="uniquename"
          placeholder='DD/MM/YYYY'
        />
      </div>
    
      <canvas id='session_map_canvas'> </canvas>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import * as ChartGeo from 'chartjs-chart-geo'
import Chart from 'chart.js';
import AdminClient from '@/api/AdminClient';
import us from "./states-10m.json"
import Datepicker from 'vuejs-datepicker';

Vue.use(Chartkick.use(Chart));

export default {
    name: 'SessionByState',
    components: {
    Datepicker
  },
    data() {
        return {
        adminClient: new AdminClient(this.$http),
        chart:null,
        originalStateObj:{},
        stateObj:{},
        startDate:null,
        endDate: null
         }
    },
    async mounted() {
     this.dateSelected()
     this.mapBuild()
    },
      asyncComputed:{
        async total() {
           this.adminClient.getSessionsByState().then((res) => {
                  const totalObj = {}
                  res.results.forEach((obj) => {
                    const value = obj.state
                    if (!totalObj[value]) {
                      const date = new Date(obj.date)
                        totalObj[value] = [date]
                    } else {
                      const date = new Date(obj.date)
                        totalObj[value].push(date)
                    }
                  })
                  this.originalStateObj = totalObj
                  this.stateObj = totalObj
                  this.mapBuild()
          
           })
        },
      },
      methods:{
         mapBuild() {
                  let canvas = document.getElementById("session_map_canvas")
                  if (!canvas) return
                      const nation = ChartGeo.topojson.feature(us, us.objects.nation).features[0];
                      const states = ChartGeo.topojson.feature(us, us.objects.states).features;
                      states.forEach((s) => {
                              if (this.stateObj.hasOwnProperty(s.properties.name)) {
                                 s.sessions = this.stateObj[s.properties.name]
                              }
                              })

                      this.chart = new Chart(canvas.getContext("2d"), {
                        type: 'choropleth',
                        data: {
                          labels: states.map(d =>  d.properties.name + " Total Sessions"),
                          datasets: [{
                            label: 'States',
                            outline: nation,
                            data: states.map((d) => ({feature: d, value: d.sessions ? d.sessions.length : 0 })),
                          }]
                        },
                        options: {
                          legend: {
                            display: false
                          },
                          scale: {
                            projection: 'albersUsa'
                          },
                          geo: {
                            colorScale: {
                              display: true,
                              position: 'bottom',
                              quantize: 5,
                              legend: {
                                position: 'bottom-right',
                              },
                            },
                          },
                        }
                      });   
              },
      dateSelected() {
        const objCopy = { }
        for (const items in this.originalStateObj) {
          objCopy[items] = this.originalStateObj[items].filter(date => (this.startDate == null || this.startDate < date) && (this.endDate == null || date < this.endDate)) 
        }
        this.stateObj = objCopy
        this.mapBuild()
      },
      resetData(){
        this.stateObj = this.originalStateObj
        this.startDate=null
        this.endDate = null
        this.mapBuild()
      }
         
      }
    
}
</script>
